import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  brandListData: [],
};

export const brandsSlice = createSlice({
  name: "brands",
  initialState,
  reducers: {
    setBrandListingData: (state, action) => {
      console.log("coming here", action);
      state.brandListData = action.payload;
    },
  },
});

export const { setBrandListingData } = brandsSlice.actions;

const brandSliceReducer = brandsSlice.reducer;

export default brandSliceReducer;
